import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CoilCalculator, CoilCalculatorResult } from '../models/coil-calculator';
import { CLAIM_SERVER_URL } from '../../config';

const COIL_CALCULATOR_V1_URL = `${ CLAIM_SERVER_URL }/v1/calculator/coil`;

@Injectable({ providedIn: 'root' })
export class CoilCalculatorService {
	coilCalculator = new CoilCalculator();

	constructor(
		private readonly http: HttpClient,
	) {}

	coilCalculatorResult(coilCalculator: CoilCalculator) {
		const url = new URL(COIL_CALCULATOR_V1_URL);
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http.post<CoilCalculatorResult>(url.toString(), coilCalculator, { headers });
	}
}
